import React from "react";
import { useTranslation } from "react-i18next";

import { ToggleButton } from "./toggleButton";
import { Props } from "./types";
import styles from "./styles.scss";

function DisplayToggle({ isDisplayingTeam, toggle, isDisable }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.displayToggle}>
      <ToggleButton
        isActive={isDisplayingTeam}
        isDisable={isDisable}
        toggle={toggle}
      />
    </div>
  );
}

export { DisplayToggle };
